import { render, staticRenderFns } from "./houseInfo.vue?vue&type=template&id=22f06ed0&scoped=true"
import script from "./houseInfo.vue?vue&type=script&lang=js"
export * from "./houseInfo.vue?vue&type=script&lang=js"
import style0 from "./houseInfo.vue?vue&type=style&index=0&id=22f06ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f06ed0",
  null
  
)

export default component.exports